<template>
  <el-dialog v-el-drag-dialog custom-class="" :close-on-click-modal="false" :visible.sync="innerVisible" :title="$t('FinanceManage.charge_deleteAdjustment')" width="500px" @close="cancel">
    <div class="app-main-inner-row" style="padding-bottom: 10px;">
      <el-form :label-width="isZh ? '100px' : '160px'" label-position="left" @submit.native.prevent>
        <div class="el-form-item-wrapper">
          <el-form-item :label="$t('SeaExport.AuditDate')">
            <el-date-picker
              v-model="accountDate"
              no="accountDate"
              type="date"
              style="width:251px;"
              clearable
            />
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div slot="footer">
      <div style="position:absolute;left: 40px;color: red;font-weight: bold;">
        <span>{{ $t('FinanceManage.FeeWillBeDeleted', [charges.length]) }}</span>
      </div>
      <div>
        <el-button no="Confirm" type="primary" size="mini" @click="confirm">{{ $t('Clearing.Confirm') }}</el-button>
        <el-button no="Cancel" size="mini" @click="cancel">{{ $t('Clearing.Cancel') }}</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>

import moment from 'moment'
import { Charge } from '@/class/model/act/Charge'
import ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import { CHARGE_SOURCE_RED_FLUSH } from '@/class/cargo/model/parameters/SystemConstants'
import { cache, cacheName } from '@/utils/cacheManager'
import { getJobByUuid, saveAdjustJob } from '@/api/booking/job'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { Job } from '@/class/model/booking/Job'

export default {
  name: 'DeleteAdjustDialog',
  components: { },
  props: {
    visible: { type: Boolean, required: true },
    charges: { type: Array, required: true },
    job: { type: Object, required: true },
    isAr: { type: Boolean, required: true },
    location: { type: String, required: false }
  },
  data() {
    return {
      innerVisible: false,
      accountDate: new Date(),
      pickerOptions: {
        disabledDate: this.disabledDate
      },
      isVerifiedAmount: false, // 费用调整是否直接销账掉
      openHecConfig: false,
      openSapConfig: false, // 打开Sap配置
      getFeeRateType: false, // 0（红冲费用取原费用的汇率，即维持现状）；可选项1（红冲费用取调整界面录入的汇率，即跟增加出来的费用汇率一致）
      loading: null,
      userId: 0,
      officeId: 0,
      departmentId: 0
    }
  },
  computed: {
    isZh() {
      return this.$store.getters.language === 'zh'
    }
  },
  watch: {
    visible: {
      handler(newVal) {
        this.innerVisible = newVal
        if (newVal) {
          this.accountDate = moment(new Date()).format('yyyy-MM-DD')
          this.onShow()
          this.userId = this.$store.getters.userId
          this.officeId = this.$store.getters.currentOfficeId
          this.departmentId = this.$store.getters.currentDeptId
        }
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    async initializeHandler() {
      this.openSapConfig = parseInt(cache.config.get('openSapConfig')) === 1
      this.openHecConfig = parseInt(cache.config.get('openHecConfig')) === 1
      this.getFeeRateType = parseInt(cache.config.get('getFeeRateType')) === 1
      this.isVerifiedAmount = parseInt(cache.config.get('VerifiedJustCharge')) === 1
    },
    async onShow() {
      await cache.load(cacheName.CONFIG)
      await this.initializeHandler()
    },
    disabledDate(currDate) {
      return currDate > new Date()
    },
    cancel() {
      this.accountDate = null
      this.innerVisible = false
    },
    async confirm() {
      if (this.charges && this.charges.length > 0) {
        if (!await this.validateCharge()) {
          return
        }
        const result = []
        for (const charge of this.charges) {
          const item = new Charge().fillDefaultValue().getData()
          item.chargeItemId = charge.chargeItemId
          item.receivable = charge.receivable
          item.oversea = charge.oversea
          item.shared = charge.shared
          item.shareRefNo = charge.shareRefNo
          item.commission = charge.commission
          item.advance = charge.advance
          item.prepaid = charge.prepaid
          item.accountId = charge.accountId
          item.currency = charge.currency
          item.measure = charge.measure
          item.quantity = charge.quantity
          item.unitRate = -(Number(charge.unitRate) || 0)
          item.branchId = charge.branchId
          item.containerNo = charge.containerNo
          item.chargeState = charge.chargeState
          item.confirmState = charge.confirmState
          item.sapStatus = charge.sapStatus
          item.settleDepartmentPrefix = charge.settleDepartmentPrefix
          item.inputBy = this.userId
          item.inputDate = new Date()
          item.inputByDep = charge.inputByDep

          item.auditor = this.userId
          item.auditDate = this.accountDate
          item.exchangeRate = charge.exchangeRate
          item.needInvoice = charge.needInvoice
          item.controlled = charge.controlled
          item.amount = -charge.amount
          item.unitPriceIncludeTax = charge.unitPriceIncludeTax
          item.taxRate = ChargeUtils.getRoundingValue(Number(charge.taxRate))
          item.taxAmount = -ChargeUtils.getRoundingValue(Number(charge.taxAmount))
          item.excludingTaxAmount = -ChargeUtils.getRoundingValue(charge.excludingTaxAmount)
          if (this.isVerifiedAmount) {
            item.verifiedAmount = item.amount
            item.paidOff = true
            charge.verifiedAmount = charge.amount
            charge.paidOff = true
          }
          item.adjustment = true
          item.offsetState = 2
          item.accountingDate = this.accountDate
          item.contactPerson = charge.contactPerson
          item.remarks = charge.remarks
          item.relatedMbl = charge.relatedMbl
          item.relationContainerNo = charge.relationContainerNo
          item.jobUuid = charge.jobUuid
          item.chargeSource = CHARGE_SOURCE_RED_FLUSH.code
          item.relatedId = charge.chargeId
          charge.offsetState = 1
          // CARGO-7916 更新费用序号
          item.serialNumber = this.refreshSerialNumber(this.isAr, this.job.charges)
          item.settlementAgentId = charge.settlementAgentId
          result.push(item)
          result.push(charge)
        }
        this.loading = getLoading4Cxt()
        if (this.job) { // 增加调整、修改调整、删除调整时校验是否被锁定
          try {
            const curJob = await getJobByUuid(this.job.uuid).then(res => res.data)
            if (curJob) {
              const receivableChargeLockedStatus = curJob.receivableChargeLockedStatus || 0
              const payableChargeLockedStatus = curJob.payableChargeLockedStatus || 0
              if ((this.isAr && receivableChargeLockedStatus === 1) || !this.isAr && payableChargeLockedStatus === 1) {
                this.$message.warning(this.$t('Message.DataHadUpdated'))
                if (this.loading) this.loading.close()
                return
              }
            }
          } catch (error) {
            this.$message.error(error)
            this.closeLoading()
            return
          }
        }
        await saveAdjustJob(result, { editMode: 'del', location: this.location }).then(res => {
          if (res.data) {
            this.$emit('returnCall', res.data)
            this.cancel()
          }
        }).finally(() => {
          this.$nextTick(() => {
            this.closeLoading()
          })
        })
      }
    },
    refreshSerialNumber(isAr, charges) {
      let number = 1
      if (!charges) return number
      for (const c of charges) {
        if (c.receivable === isAr) {
          number++
        }
      }
      return number
    },
    async validateCharge() {
      const job = new Job(this.job)
      if (job && job.charges && job.charges.length > 0) {
        for (const c of this.job.charges) {
          if (!c.uuid) return false
        }
      }
      if (!this.accountDate) {
        this.$message.warning(this.$t('Message.DateOfAdjustmentCannotBeNull'))
        return false
      }
      return true
    },
    closeLoading() {
      if (this.loading) {
        this.loading.close()
      }
    }
  }
}
</script>

<style lang="scss">
</style>
